'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import Modal, { ModalAction, ModalBody, ModalHead } from '@/components/@base/modal';

import useCommonModalStore from '@/store/common-modal-store';

export default function CommonModal() {
  const {
    setShow,
    show,
    Head,
    Body,
    Action,
    DialogProps,
    DialogPanelProps,
    onDemandClose,
    noBackDrop,
    center,
  } = useCommonModalStore();

  function onClose() {
    !onDemandClose && setShow(false);
  }

  const pathname = usePathname();
  useEffect(() => {
    setShow(false);
  }, [pathname]);

  return (
    <Modal
      show={show}
      noBackDrop={noBackDrop}
      center={center}
      onClose={onClose}
      dialogPanelProps={DialogPanelProps || undefined}
      dialogProps={DialogProps || undefined}
    >
      {Head && (
        <ModalHead isCustomHead>
          <Head />
        </ModalHead>
      )}
      <ModalBody className='flex min-h-0 flex-1 flex-col gap-2.5 text-right'>
        <Body />
      </ModalBody>
      {Action && (
        <ModalAction>
          <Action />
        </ModalAction>
      )}
    </Modal>
  );
}
